import { useState } from "react";

const appFeatures = [
  { icon: "ri-qr-scan-2-line", text: "扫码识款，对准实物立刻识别型号与资料库条目" },
  { icon: "ri-heart-3-line", text: "收藏跨端同步，手机电脑看到哪收到哪" },
  { icon: "ri-notification-3-line", text: "到货 / 补货 / 预售提醒，抢购不再错过" },
  { icon: "ri-graduation-cap-line", text: "测评与论坛随身带走，通勤路上也能刷" },
];

export default function AppDownload() {
  const [subscribed, setSubscribed] = useState(false);

  return (
    <section id="download" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-smartphone-line" />
              78动漫 App 4.0
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              把测评、资料库和论坛，装进口袋
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              210 万同好正在使用。扫码识款、收藏同步、到货提醒一站配齐，出门在外也能随时查资料、刷热帖。
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {appFeatures.map((feature) => (
                <li key={feature.icon} className="flex items-start gap-2.5">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${feature.icon} text-sm`} />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{feature.text}</span>
                </li>
              ))}
            </ul>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#download"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                <i className="ri-apple-fill text-base" />
                下载 iOS 版
              </a>
              <a
                href="#download"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-android-fill text-base" />
                下载 Android 版
              </a>
              <button
                type="button"
                onClick={() => setSubscribed((v) => !v)}
                className={`flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors ${
                  subscribed
                    ? "bg-accent-500 text-background-50"
                    : "bg-primary-500 text-background-50 hover:bg-primary-600"
                }`}
              >
                <i className={subscribed ? "ri-check-line" : "ri-notification-3-line"} />
                {subscribed ? "已订阅新品提醒（演示）" : "订阅新品提醒"}
              </button>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="relative w-full max-w-sm">
              <div className="relative h-[380px] w-full overflow-hidden rounded-xl border border-background-200 md:h-[440px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20anime%20figure%20collection%20app%20interface%20with%20clean%20card%20layout%20on%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20minimal%20editorial%20product%20photography%2C%20muted%20warm%20palette%2C%20high%20detail&width=800&height=1000&seq=78dm-app-phone&orientation=portrait"
                  alt="78动漫 App 手机端界面展示"
                  title="78动漫 App 模型手办资料库"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute -left-4 bottom-6 hidden rounded-lg border border-background-200 bg-background-50 p-4 sm:block">
                <p className="text-xs text-foreground-500">扫码识款命中率</p>
                <p className="mt-0.5 font-heading text-xl font-bold text-primary-600">98.6%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}